// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------
import { createEnum } from "@cartographerio/util";
const WaterOdours = "waterOdours";
const SedimentOdours = "sedimentOdours";
const Oils = "oils";
const SurfaceScum = "surfaceScum";
const GrossPollution = "grossPollution";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const UrsPollutionIndicatorEnum = {
    ...createEnum("UrsPollutionIndicator", [
        [WaterOdours, "Water odours"],
        [SedimentOdours, "Sediment odours"],
        [Oils, "Oils"],
        [SurfaceScum, "Surface scum"],
        [GrossPollution, "Gross pollution"],
    ]),
    WaterOdours,
    SedimentOdours,
    Oils,
    SurfaceScum,
    GrossPollution,
};
null;
null;
export default UrsPollutionIndicatorEnum;
//# sourceMappingURL=UrsPollutionIndicatorEnum.generated.js.map